import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import createPersistedState from 'vuex-persistedstate'
import vueAuthInstance from '../services/authenticationService.js'

import academicYear from './modules/academicYear'
import activeCourse from './modules/activeCourse'
import activityGen from './modules/activityGen'
import activityGenStaff from './modules/activityGenStaff'
import activityNonGen from './modules/activityNonGen'
import activityType from './modules/common/activityType'
import attachmentDocument from './modules/common/attachmentDocument'
import building from './modules/common/building'
import coursePlan from './modules/coursePlan'
import department from './modules/common/department'
import instructor from './modules/instructor'
import internetRequest from './modules/internetRequest'
import parkingRequest from './modules/parkingRequest'
import personType from './modules/common/personType'
import person from './modules/person'
import requestType from './modules/common/requestType'
import room from './modules/common/room'
import section from './modules/section'
import sectionDepartment from './modules/sectionDepartment'
import studentRequest from './modules/studentRequest'
import subSection from './modules/subSection'
import snackbar from './modules/common/snackbar'
import subject from './modules/common/subject'
import timesheet from './modules/timesheet'
import university from './modules/common/university'
import wage from './modules/wage'
import wageRate from './modules/common/wageRate'

Vue.use(Vuex)
Vue.use(VueAxios, axios)

function initialState () {
  return {
    drawer: true,
    miniVariant: false,
    profile: {},
    isAuthenticated: false
  }
}

const store = new Vuex.Store({
  state: initialState,
  getters: {
    token: () => {
      return vueAuthInstance.getToken()
    },
    roles: state => {
      return (state.profile.roles) ? state.profile.roles : []
    },
    username: state => {
      return state.profile.username
    },
    fullname: state => {
      return state.profile.fullname
    },
    email: state => {
      return state.profile.email
    }
  },

  mutations: {
    isAuthenticated (state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated
    },
    profile (state, profile) {
      state.profile = profile
    },
    reset (state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    }
  },

  actions: {
    login (context, payload) {
      payload = payload || {}
      return vueAuthInstance.login(payload.user, payload.requestOptions)
        .then((response) => {
          // console.log('login', response.data)
          context.commit('isAuthenticated', vueAuthInstance.isAuthenticated())
          context.commit('profile', response.data)
          return response
        })
    },

    register (context, payload) {
      payload = payload || {}
      return vueAuthInstance.register(payload.user, payload.requestOptions).then(function () {
        context.commit('isAuthenticated', vueAuthInstance.isAuthenticated())
      })
    },

    logout (context, payload) {
      payload = payload || {}
      return vueAuthInstance.logout(payload.requestOptions).then(function () {
        context.commit('isAuthenticated', vueAuthInstance.isAuthenticated())
        context.commit('profile', {})
        context.commit('reset')
      }).catch(() => {
        context.commit('isAuthenticated', false)
        context.commit('profile', {})
        context.commit('reset')
      })
    },

    authenticate (context, payload) {
      payload = payload || {}
      return vueAuthInstance.authenticate(payload.provider, payload.userData, payload.requestOptions).then((response) => {
        context.commit('isAuthenticated', vueAuthInstance.isAuthenticated())
      })
    },

    loading (context, payload) {
      console.log('loading', payload)
      if(!payload) {
        setTimeout(() => context.commit('loading', payload), 500)
      } else {
        context.commit('loading', payload)
      }
    }
  },

  modules: {
    academicYear,
    activeCourse,
    activityGen,
    activityGenStaff,
    activityNonGen,
    activityType,
    building,
    coursePlan,
    department,
    instructor,
    internetRequest,
    parkingRequest,
    personType,
    person,
    requestType,
    room,
    section,
    sectionDepartment,
    subSection,
    snackbar,
    studentRequest,
    subject,
    timesheet,
    university,
    wage,
    wageRate,
    attachmentDocument
  },

  //plugins: [createPersistedState({ storage: window.sessionStorage })]
  plugins: [createPersistedState()]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js